import { CARD_API_ENDPOINT } from '@/config/consts'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccount } from 'wagmi'
import { createSmartFetch } from './useAuthenticatedMutation'

interface UpdateLabelRequest {
  cardID: string
  label: string
}

export function useUpdateCardLabel() {
  const { address } = useAccount()
  const queryClient = useQueryClient()
  const url = `${CARD_API_ENDPOINT}/v1/vendor/cards/label`

  const mutation = useMutation<void, Error, UpdateLabelRequest>({
    mutationKey: ['update-card-label'],
    mutationFn: async (request: UpdateLabelRequest) => {
      const fetchFn = createSmartFetch(url, { method: 'PATCH' })
      await fetchFn(request)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user-cards', address] })
    },
  })

  return {
    updateLabel: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  }
}
